import { render, staticRenderFns } from "./Bahn1View.vue?vue&type=template&id=1e35ced7&scoped=true&"
import script from "./Bahn1View.vue?vue&type=script&lang=js&"
export * from "./Bahn1View.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1View.vue?vue&type=style&index=0&id=1e35ced7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e35ced7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
